import { render } from "./B2BAuthComponent.vue?vue&type=template&id=b1223e8e&scoped=true"
import script from "./B2BAuthComponent.vue?vue&type=script&lang=js"
export * from "./B2BAuthComponent.vue?vue&type=script&lang=js"

import "./B2BAuthComponent.vue?vue&type=style&index=0&id=b1223e8e&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/byb-front/byb-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b1223e8e"]])

export default __exports__